import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
    selector: 'tooltip-image-preview',
    templateUrl: './image-preview.modal.component.html',
    styleUrls: [
        './image-preview.scss'
    ]
})
export class ToolTipImagePreviewModalComponent implements OnInit {
    @Input() imagePath: string;

    constructor(
        public modalRef: BsModalRef,
    ) {}

    ngOnInit() {}

    close(): void {
        this.modalRef.hide();
    }
}





// WEBPACK FOOTER //
// ./src/app/shared/components/image-previwer/image-preview.modal.component.ts